module.exports = __webpack_public_path__ + "img/CSS.d74034ad.svg";